import './ReactTable.scss'
import { useEffect, useRef, useState } from 'react'

import { ButtonTypes } from '@cox/core-ui8/dist/Button'

import { ComparisonTableVariation, HeaderTheme, ReactTableProps, TableVariation } from './types'
import { handleModal } from '../../utils/modal-util'
import { getSpacing } from '../../utils/spacing-util'
import ReactButton from '../ReactButton'
import ReactText from '../ReactText'
import IsInEditorText from '../shared/IsInEditorText'

const ReactTable = (props: ReactTableProps): JSX.Element => {
  const {
    buttonCollapse,
    buttonExpand,
    id,
    isInEditor = false,
    isSecondary,
    tableId = '',
    text = '',
    top = false,
    right = false,
    bottom = false,
    left = false,
    lob = '',
    tableVariation = TableVariation.COMPARISON,
    headerTheme = HeaderTheme.DARK,
    alignment = 'left',
    tokenProperties = ''
  } = props

  const editorRef = useRef<any>(null)

  useEffect(() => {
    const editor = editorRef.current
    if (editor) {
      editor?.addEventListener('click', handleModal)
    }
  }, [])

  let comparisonTableVariation: string, defaultDisplayStyle
  if (isSecondary) {
    comparisonTableVariation = ComparisonTableVariation.SECONDARY
    defaultDisplayStyle = 'none'
  } else {
    comparisonTableVariation = ComparisonTableVariation.PRIMARY
    defaultDisplayStyle = 'block'
  }

  const [buttonText, setButtonText] = useState(buttonExpand)
  const [displayStyle] = useState(defaultDisplayStyle)
  const [spacingStyle, setSpacingStyle] = useState(getSpacing(top, right, bottom, left))

  const handleClick = () => {
    /* Update button text */
    if (buttonText == buttonExpand) {
      setButtonText(buttonCollapse)
    } else setButtonText(buttonExpand)
    /* Show/hide secondary table */
    const secondaryTable = document.getElementById(tableId)
    if (secondaryTable && secondaryTable.style.display == 'block') {
      secondaryTable.style.display = 'none'
      setSpacingStyle(getSpacing(top, right, bottom, left))
    } else if (secondaryTable && secondaryTable.style.display == 'none') {
      secondaryTable.style.display = 'block'
      setSpacingStyle(getSpacing(top, right, false, left))
    }
  }

  const getContainerStyle = (comparisonTableVariation: string) => {
    if (comparisonTableVariation == ComparisonTableVariation.PRIMARY) {
      return spacingStyle + ' ' + lob
    } else if (comparisonTableVariation == ComparisonTableVariation.SECONDARY && left && right) {
      return 'container'
    }
  }

  const getClassname = () => {
    const defaultClassname = `react-table ${tableVariation}-table`
    if (tableVariation === TableVariation.COMPARISON) {
      return `${defaultClassname} ${comparisonTableVariation}-table ${
        comparisonTableVariation === ComparisonTableVariation.SECONDARY && bottom && 'secondary-table-margin-expanded'
      }`
    } else {
      return `${defaultClassname} ${headerTheme} ${alignment}`
    }
  }

  return (
    <div
      data-testid='react-table-container'
      className={`react-table-container ${getContainerStyle(comparisonTableVariation)}`}
    >
      {IsInEditorText(isInEditor, 'React Table')}

      <div id={id} className={getClassname()} style={{ display: displayStyle }} ref={editorRef}>
        {text && <ReactText text={text} tokenProperties={tokenProperties} />}
      </div>

      {tableId && tableVariation === TableVariation.COMPARISON && (
        <div className='comparison-table react-table-button-section'>
          <ReactButton
            id='react-table-button'
            text={buttonText}
            buttonTypes={ButtonTypes.PRIMARY}
            customClickEvent={() => handleClick()}
          />
        </div>
      )}
    </div>
  )
}

export default ReactTable
